import React from "react";
import Image from "next/image";
import { TopBrandsSection } from "@/.storyblok/types/319751/storyblok-components";
import Testimonial from "@/components/Testimonial";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { StoryblokAsset } from "storyblok";

interface TopBrandsSectionProps {
  blok?: TopBrandsSection & SbBlokData;
}

const TopBrandsSectionComponent: React.FC<TopBrandsSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { brands, testimonials, title, subtitle, type, bg_style } = blok;

  const backgroundClass = bg_style === 'dark' ? 'bg-light' : '';

  const renderBrand = (brand: StoryblokAsset) => {
    if (!brand?.filename) return null;

    return (
      <div className="col-auto" key={brand.id}>
        <Image
          src={brand.filename}
          width={150}
          height={75}
          alt={brand.alt || "Brand Logo"}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          loading="lazy"
          quality={75}
        />
      </div>
    );
  };

  return (
    <div {...storyblokEditable(blok)} className={`section-brands ${backgroundClass} py-4 py-md-5`}>
      <div className="container">
        {title && <h2 className="text-center text-primary">{title}</h2>}
        {subtitle && <p className="text-center">{subtitle}</p>}

        {type === "trusted" && (
          <p className="mb-4 fw-bold text-center small text-uppercase">
            Rated 5 stars on Google
            <span className="text-gold ms-2">
              {[...Array(5)].map((_, index) => (
                <i key={index} className="fas fa-star me-1" />
              ))}
            </span>
          </p>
        )}

        {type === "trusted" && brands && brands.length > 0 && (
          <div className="row justify-content-center align-items-center g-3 g-sm-4 mb-5">
            {brands.map((brand) => renderBrand(brand))}
          </div>
        )}

        {testimonials && testimonials.length > 0 && (
          <Testimonial
            hideHeading
            testimonials={testimonials.filter((item): item is any =>
              Boolean(item) && typeof item === 'object' && 'content' in item
            )}
          />
        )}
      </div>
    </div>
  );
};

export default TopBrandsSectionComponent;